import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CheckoutSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const orderNumber = location.state?.orderNumber || 'Unknown';

    return (
        <div className="checkout-container">
            <div className="order-success-message">
                <div className="success-icon">
                    <span style={{ fontSize: '48px', color: '#22c55e' }}>✓</span>
                </div>

                <h1>Order Placed Successfully!</h1>
                <p className="order-number">
                    Your order number is: <strong>{orderNumber}</strong>
                </p>
                <p>You will receive a confirmation email shortly.</p>

                <div className="success-actions">
                    <button
                        onClick={() => navigate('/')}
                        className="btn-primary"
                        style={{ marginTop: '2rem' }}
                    >
                        Continue Shopping
                    </button>

                    <button
                        onClick={() => navigate('/my-account', { state: { activeTab: 'orders' } })}
                        className="btn-secondary"
                        style={{ marginTop: '1rem', marginLeft: '1rem' }}
                    >
                        View My Orders
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CheckoutSuccess;